export const rewardCatalog = {
  core: [
    {
      id: "safety-vest",
      name: "Hi-Vis Safety Vest",
      sku: "LSR-VEST-01",
      description: "Reflective vest with front zipper and segmented striping for daily dock and yard use.",
      image: "https://www.stran.store/media/catalog/product/u/s/usap-040-bk_1.jpg",
      sizes: ["M", "L", "XL", "2XL", "3XL"],
      colors: ["Safety Yellow", "Safety Orange"],
      personalization: false,
      badge: "Popular"
    },
    {
      id: "rain-jacket",
      name: "Water Resistant Shell",
      sku: "LSR-SHELL-02",
      description: "Lightweight outer shell designed for early starts, wind, and light rain.",
      image: "https://www.stran.store/media/catalog/product/c/t/ctr-5409_apex_barrier_soft_shell_jacket_1.jpg",
      sizes: ["S", "M", "L", "XL", "2XL"],
      colors: ["Navy", "Steel Gray"],
      personalization: true,
      badge: "New"
    }
  ],
  premium: [
    {
      id: "duffel",
      name: "Safety Gear Duffel",
      sku: "LSR-DUFFEL-03",
      description: "Structured duffel for gloves, safety glasses, paperwork, and personal essentials.",
      image: "https://www.stran.store/media/catalog/product/c/t/ctr-5409_apex_barrier_soft_shell_jacket_1.jpg",
      sizes: ["One Size"],
      colors: ["Black", "Navy"],
      personalization: true,
      badge: "Essentials"
    },
    {
      id: "outerwear-kit",
      name: "Outerwear Recognition Kit",
      sku: "LSR-KIT-04",
      description: "Tiered award bundle with jacket, knit cap, and accessory pouch for top recognition levels.",
      image: "https://www.stran.store/media/catalog/product/u/s/usap-040-bk_1.jpg",
      sizes: ["M", "L", "XL", "2XL"],
      colors: ["Navy"],
      personalization: true,
      badge: "Tier Award"
    }
  ]
};

export const mockDriverAccess = {
  "123456": {
    driverName: "Robert Miles",
    rewardTier: "Core Safety Tier",
    rewardGroup: "core",
    lNumber: "L-20415",
    tierYear: "5 Year",
    eligibilityMonth: "June 2026"
  },
  "654321": {
    driverName: "Angela Carter",
    rewardTier: "Premium Recognition Tier",
    rewardGroup: "premium",
    lNumber: "L-11842",
    tierYear: "9 Year",
    eligibilityMonth: "June 2026"
  },
  "777777": {
    driverName: "Michael Dunn",
    rewardTier: "Manual Review Required",
    rewardGroup: "manual",
    lNumber: "L-99991",
    tierYear: "15 Year Ring",
    eligibilityMonth: "June 2026",
    manualMessage:
      "This milestone reward is handled outside the self-service storefront. Please contact the Landstar Safety Awards team for assisted processing."
  }
};

export const allowedCountries = [
  {
    code: "US",
    name: "United States",
    regions: [
      "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "FL", "GA",
      "IA", "ID", "IL", "IN", "KS", "KY", "LA", "MA", "MD", "ME",
      "MI", "MN", "MO", "MS", "MT", "NC", "ND", "NE", "NH", "NJ",
      "NM", "NV", "NY", "OH", "OK", "OR", "PA", "RI", "SC", "SD",
      "TN", "TX", "UT", "VA", "VT", "WA", "WI", "WV", "WY"
    ]
  },
  {
    code: "CA",
    name: "Canada",
    regions: ["AB", "BC", "MB", "NB", "NL", "NS", "NT", "NU", "ON", "PE", "QC", "SK", "YT"]
  },
  {
    code: "PR",
    name: "Puerto Rico",
    regions: ["PR"]
  }
];
